<template>
    <div class="info-outer-wrapper">
        <div class="doc-type-wrapper">
            <span>DOCUMENTE CE VOR FI PREGĂTITE (COMPLETATE MANUAL) ÎN FUNCȚIE DE SPECIFICUL FIECĂRUI PROIECT</span>
        </div>
        <div class="info-checklist-wrapper">
<!--            <div class="inner-section">
                <h4 class="bullet">Certificat de urbanism și copia cererii de eliberare a Certificatului de urbanism (unde este cazul)</h4>
            </div>-->
            <div class="inner-section">
                <h4 class="bullet">Contract de concesiune / contract de superficie /contract de comodat/ contract de închiriere) (după caz) </h4>
                <p>(în cazul închirierii de la o persoană fizică, contractul să fie înregistrat la organele fiscale din subordinea Agenţiei Naţionale de Administrare fiscală).</p>
            </div>
            <div class="inner-section">
                <h4 class="bullet">Titlu de proprietate/contractul de vânzare – cumpărare aplicabil numai solicitanților care dețin clădirea la momentul depunerii cererii de finanțare.</h4>
                <p>În cadrul activității de modernizăre a spațiului de producție/servicii, în cadrul etapei de depunere a propunerilor de proiecte, solicitantul va depune un deviz estimativ și documente care să 
                    demonstreze dreptul de proprietate, concesiune, superficie sau chirie/comodat cu privire la imobilul (clădire) unde se face investiția.</p>
            </div>
            <div class="inner-section">
                <h4>În cadrul planului de afaceri, solictantul trebuie să demonstreze că modernizarea spațiului de producție/servicii contribuie la obiectivele de mediu, dacă este cazul.</h4>
            </div>
        </div>
        <div class="doc-type-wrapper">
            <span>DOCUMENTE CE VOR FI PREGĂTITE IN FAZA DE CONTRACTARE (PROIECT CÂȘTIGĂTOR)</span>
        </div>
        <div class="info-checklist-wrapper">
<!--            <div class="inner-section">
                <h4 class="bullet">DALI (în cazul modernizării spațiului de producție/servicii) </h4>
            </div>-->
            <div class="inner-section">
                <h4 class="bullet">Extras de carte funciară, care să probeze faptul că imobilul unde se realizează investiția este liber de orice sarcină (după caz) </h4>
            </div>
            <div class="inner-section">
                <h4 class="bullet">Cazier judiciar al reprezentantului legal al solicitantului</h4>
            </div>
            <div class="inner-section">
                <h4 class="bullet">Cazier fiscal al reprezentantului legal al solicitantului</h4>
            </div>
        </div>
    </div>
</template>
<script>

    export default {

    }
</script>
<style scoped>
.info-checklist-wrapper {
    background-color: #ffffff;
}
span {
    color:#856882;
    font-size: 11px;
    font-weight: bold;
    display: block;
    padding-left: 100px;
}
.doc-type-wrapper {
    background-color: #d6d8dd;
    padding: 10px 0px;

}
.info-checklist-wrapper {
    padding: 30px 100px;
}
h3{
    text-transform: uppercase;
    font-size: 16px;
    font-weight: bold;
    color:#777e90;
    margin-bottom: 25px;
}
h4{
    font-size: 14px;
    font-weight: bold;
    color:#777e90;
    margin-bottom: 0px;
    position: relative;

}
p{
    margin-bottom: 8px;
    color:#b4bacb;
    font-style: italic;
}
ul {
    list-style: inside;
}
ul li {
    font-size: 12px;
    margin-bottom: 8px;
}
ul li div {
    font-size: 18px;
}
.inner-section {
    margin-bottom: 25px;
}
.incarcare-doc {
    display: flex;
    background-color: #ffffff;
    align-items: center;
    margin:10px 0px;
    padding: 8px;
    border-radius: 10px;
    width: fit-content;
}
.icon-x {
    color:red;
    margin-right: 5px;
    font-size: 20px;
    cursor: pointer;
}
.icon-upload {
    margin-right: 5px;
    color:#d2d2d2;
    cursor: pointer;
}
.bullet::before{
    content:'';
    display: block;
    width: 10px;
    height: 10px;
    border:2px solid #ffffff;
    background-color:#6d0cc2;
    position: absolute;
    left: -37px;
    top: 2px;
}
</style>